export default class DtoHydrogeologicalEntity {
    constructor(obj) {
        this.code = obj.code
        this.name = obj.name
        this.startDate = obj.startDate
        this.state = obj.state
        this.sandreCode = obj.sandreCode
    }
}
